import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookEditBasics } from "@shared/models/analytics/planbook"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import Patch from "@shared/models/patch-updater"
import _ from "lodash"
import type { Narrative } from "../create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

export const PLANBOOK_CHANGE_COURSE_ORDER = {
  name: "PLANBOOK_CHANGE_COURSE_ORDER",

  params: {
    planbookId: "string",
    cover: "string",
  },

  patches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).set(
      "relationships.courses.data",
      _.map(payload.courseIds, (id) => {
        return { id: id, type: "course" }
      })
    ).patch
    return [patch]
  },

  undoPatches: null,

  narrative(payload, findFn: FindFn, userId): Narrative {
    let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)

    let newEvent: PlanbookEditBasics = {
      ...createBlankEvent(),
      root_id: payload.planbookId,
      root_type: "planbook",
      primary_object_id: payload.planbookId,
      primary_object_id_and_ancestor_ids: [payload.planbookId],
      primary_object_type: "planbook",
      primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),
      primary_verb: "edit",
      primary_object_specifier: "courses",
      adverbial_verb: "reordering",
    }

    return {
      title: "Changed Course Order",
      titleForAnalytics: "Planbook - Change Order of Courses",
      description: `Changed the order of courses for ${models.planbook.attributes.title} planbook`,
      context: defaultPlanbookContext(payload, models),
      activity: defaultPlanbookActivity(payload, models),
      newAnalyticsEvents: [newEvent],
    }
  },
}

export default PLANBOOK_CHANGE_COURSE_ORDER
